'use client';

import { captureException } from '@sentry/nextjs';
import { useEffect } from 'react';
import Image from 'next/image';
import { AppNextLink } from '@/features/app-next-link';
import { Button } from '@/features/button';
import { ErrorDetails } from './constants';
import { Errors } from './types';
interface Props {
  errorCode: Errors;
}
function ErrorPage({
  errorCode
}: Props) {
  const errorDetail = ErrorDetails.find(error => {
    return error.errorCode === errorCode;
  });
  useEffect(() => {
    // Log the error to Sentry
    captureException(errorDetail);
  }, [errorDetail]);
  if (!errorDetail) return <>Error!</>;
  return <div className='flex w-full flex-col items-center lg:mb-24' data-sentry-component="ErrorPage" data-sentry-source-file="error.tsx">
            <Image src={errorDetail.image} width={344} height={240} className='mb-6' unoptimized alt={errorDetail.title || errorDetail.text} data-sentry-element="Image" data-sentry-source-file="error.tsx" />

            <div className='flex flex-col items-center gap-1 text-body-14 lg:mb-6 lg:gap-2 lg:text-body-16'>
                <span className='text-text-darkGray'>{errorDetail.title}</span>
                <p className='text-center text-text-black'>{errorDetail.text}</p>
            </div>

            {errorDetail.errorCode === '404' && <div className='fixed bottom-0 left-0 w-full p-4 lg:bottom-11 lg:left-1/2 lg:w-[344px] lg:-translate-x-1/2 lg:p-0'>
                    <AppNextLink prefetch={false} href='/' className='w-full'>
                        <Button graphicStyle='outlined' size='large' className='w-full'>
                            بازگشت به خانه
                        </Button>
                    </AppNextLink>
                </div>}
        </div>;
}
export default ErrorPage;